<template>
  <o-list
    :entity="entity"
    :isAction="true"
  ></o-list>
</template>

<script>
import axios from "axios";
import mixins from "@/mixins";

import BaseList from "@/pages/BasePage/BaseList";
const entity = "location";

export default {
  mixins: [mixins],
  components: {
    "o-list": BaseList,
  },
  data: function () {
    return {
      entity,
    };
  },
  computed: {
   
  },
  watch: {},
  methods: {
    
  },
  mounted() {},
  created() {},
  destroyed() {},
};
</script>


<style lang="scss">
.card-box {
  background: #fff;
}
</style>
